import React, {ReactElement, useState} from "react";
import {
    Button,
    Card,
    CardHeader,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    useTheme
} from "@mui/material";
import {FaFileDownload, FaTable} from "react-icons/fa";

interface DashboardDownloadCardProps {
    title: string
    // icon: React.ReactElement
    preview: ReactElement,
    downloadFile: () => void
}
export const DashboardDownloadCard : React.FC<DashboardDownloadCardProps> = ({title, preview, downloadFile}) => {
    const theme = useTheme();
    const [showPreview, setShowPreview] = useState(false)

    return (
        <Card elevation={4} sx={{border: `1px solid ${theme.palette.primary.main}`, borderRadius:'10px' , position: 'relative',
            '& .MuiCardHeader-subheader': { color: 'grey', fontSize: '18px' },
            '& .MuiCardHeader-title': {fontSize: '30px', fontWeight:'bold'}
        }}>
            <CardHeader title={title} subheader={<>
                <Button size={'small'} variant={'outlined'}
                        startIcon={<FaTable />} onClick={event => {
                            setShowPreview(true);
                }}>
                    Live Vorschau
                </Button>
            </>}>
            </CardHeader>
            <div style={{position: 'absolute', top: '10px', right: '10px',
                color: theme.palette.primary.main, transform: 'rotate(0deg)'
            }}>
                <IconButton onClick={() => {
                    downloadFile();
                }}>
                    <FaFileDownload style={{color: 'green', fontSize: '60px'}} />
                </IconButton>
            </div>
            <Dialog fullWidth maxWidth={'lg'} open={showPreview}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    {preview}
                </DialogContent>
                <DialogActions>
                    <Button onClick={event => {
                        setShowPreview(false)
                    }}>Schließen</Button>
                </DialogActions>
            </Dialog>
        </Card>
    )
}